var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-label-dialog",
          attrs: {
            title: _vm.titleName,
            visible: _vm.dialogVisibleM,
            "modal-append-to-body": false,
            width: "850px",
            height: "504px",
            "close-on-click-modal": false
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function($event) {
              _vm.dialogVisibleM = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ]
            },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  staticClass: "demo-ruleForm",
                  staticStyle: { overflow: "auto", "max-height": "55vh" },
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务名称", prop: "msgName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled:
                            _vm.currentPopupType == "edit" ||
                            _vm.currentPopupType == "details",
                          size: "small",
                          "show-word-limit": "",
                          maxlength: 30,
                          placeholder: "请输入"
                        },
                        model: {
                          value: _vm.formData.msgName,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "msgName", $$v)
                          },
                          expression: "formData.msgName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "执行群聊", prop: "chatType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            disabled:
                              _vm.currentPopupType == "edit" ||
                              _vm.currentPopupType == "details"
                          },
                          model: {
                            value: _vm.formData.chatType,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "chatType", $$v)
                            },
                            expression: "formData.chatType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("全部群聊")
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("指定群聊")
                          ])
                        ],
                        1
                      ),
                      _vm.formData.chatType == 1
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              !(
                                _vm.currentPopupType == "edit" ||
                                _vm.currentPopupType == "details"
                              )
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: { click: _vm.openSelectQuPopup }
                                    },
                                    [_vm._v("+ 选择群聊")]
                                  )
                                : _vm._e(),
                              _vm.formData.chatList &&
                              _vm.formData.chatList.length
                                ? _c(
                                    "div",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [
                                      _vm._v(
                                        " 已选: " +
                                          _vm._s(_vm.formData.chatList.length) +
                                          "条 "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.formData.chatList &&
                              _vm.formData.chatList.length &&
                              !(
                                _vm.currentPopupType == "edit" ||
                                _vm.currentPopupType == "details"
                              )
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "warning", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.clearSelected()
                                        }
                                      }
                                    },
                                    [_vm._v("清空已选")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formData.chatType == 1 &&
                      _vm.formData.chatList &&
                      _vm.formData.chatList.length
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "line-height": "26px",
                                "background-color": "rgba(204, 204, 204, 0.12)",
                                padding: "10px",
                                "border-radius": "5px"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.handleChartsName()) + " ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "执行员工" } }, [
                    _c("span", [_vm._v("群主")])
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推送规则", prop: "pushType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            disabled:
                              _vm.currentPopupType == "edit" ||
                              _vm.currentPopupType == "details"
                          },
                          model: {
                            value: _vm.formData.pushType,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "pushType", $$v)
                            },
                            expression: "formData.pushType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("即时推送")
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("周期推送")
                          ])
                        ],
                        1
                      ),
                      _vm.formData.pushType == 0
                        ? _c("p", { staticClass: "tips-row" }, [
                            _vm._v(
                              "*即时推送：创建任务后，立即触发的一次性群发任务"
                            )
                          ])
                        : _vm.formData.pushType == 1
                        ? _c("div", [
                            _c("p", { staticClass: "tips-row" }, [
                              _vm._v(
                                "*周期推送：在一定时间范围内，每天指定时间推送群发任务。"
                              )
                            ]),
                            _vm.currentPopupType == "edit"
                              ? _c("div", { staticClass: "date-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "date-item" },
                                    [
                                      _c("span", [_vm._v("开始日期：")]),
                                      _c("el-date-picker", {
                                        attrs: {
                                          disabled: true,
                                          size: "mini",
                                          type: "date",
                                          placeholder: "选择日期"
                                        },
                                        model: {
                                          value: _vm.formData.pushStartTime,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "pushStartTime",
                                              $$v
                                            )
                                          },
                                          expression: "formData.pushStartTime"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "date-item" },
                                    [
                                      _c("span", [_vm._v("结束日期：")]),
                                      _c("el-date-picker", {
                                        attrs: {
                                          "picker-options":
                                            _vm.disabledBeforeDate,
                                          size: "mini",
                                          type: "date",
                                          placeholder: "选择日期",
                                          format: "yyyy-MM-dd "
                                        },
                                        on: { change: _vm.changeRangEnd },
                                        model: {
                                          value: _vm.formData.pushEndTime,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "pushEndTime",
                                              $$v
                                            )
                                          },
                                          expression: "formData.pushEndTime"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _c(
                                  "div",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        disabled:
                                          _vm.currentPopupType == "details",
                                        size: "small",
                                        type: "daterange",
                                        "picker-options": _vm.pickerOptions,
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd"
                                      },
                                      on: { change: _vm.changeRang },
                                      model: {
                                        value: _vm.pushTime,
                                        callback: function($$v) {
                                          _vm.pushTime = $$v
                                        },
                                        expression: "pushTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-right": "4px" } },
                                  [_vm._v("发送节点：每天")]
                                ),
                                _c("el-time-select", {
                                  staticStyle: { width: "130px" },
                                  attrs: {
                                    size: "small",
                                    "picker-options": {
                                      start: "00:00",
                                      step: "00:30",
                                      end: "23:30"
                                    },
                                    placeholder: "选择时间"
                                  },
                                  model: {
                                    value: _vm.formData.pushNode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "pushNode", $$v)
                                    },
                                    expression: "formData.pushNode"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#ff4b59",
                              "margin-right": "5px",
                              transform: "translate(0, 2px)"
                            }
                          },
                          [_vm._v("*")]
                        ),
                        _vm._v("发送内容 ")
                      ]),
                      _c(
                        "div",
                        { staticClass: "task-detail" },
                        [
                          _c("MyUpload", {
                            ref: "myUploadRef",
                            attrs: {
                              upLoadData: _vm.upLoadData,
                              myType: _vm.myType,
                              onlyShow:
                                (_vm.currentPopupType == "edit" ||
                                  _vm.currentPopupType == "details") &&
                                _vm.formData.pushType == 0
                                  ? true
                                  : false
                            },
                            on: { receiveParam: _vm.receiveParam }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "margin-top": "10px"
                  },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { size: "small " },
                      on: { click: _vm.closeDialog }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.currentPopupType != "details" ? "取 消" : "关 闭"
                        )
                      )
                    ]
                  ),
                  _vm.currentPopupType != "details"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.confirmWeicome()
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.showGroupSelectPopup
        ? _c("groupSelectPopup", {
            attrs: {
              dialogVisible: _vm.showGroupSelectPopup,
              disabledSelect: _vm.formData.chatList
            },
            on: {
              "update:dialogVisible": function($event) {
                _vm.showGroupSelectPopup = $event
              },
              "update:dialog-visible": function($event) {
                _vm.showGroupSelectPopup = $event
              },
              selectedData: _vm.selectedData
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }